import "./Toggle.scss";

const Toggle = ({ onSelect, selected }) => {
  const handleSelect = (option) => {
    onSelect(option);
  };

  return (
    <div>
      <div className="toggle-container">
        <div className="toggle" onClick={() => handleSelect("steer")}>
          <input type="radio" checked={selected === "steer"} />
          <label htmlFor="steer" className="toggle-label">
            Steer
          </label>
          <p className="toggle-helperText">
            For leadership, people ops, and in some cases, product and CS. If a
            team member supports both AutoOps and Steer customers, like a CSM
            after onboarding, they should use the Steer signature.
          </p>
        </div>

        <div className="toggle" onClick={() => handleSelect("autoOps")}>
          <input type="radio" checked={selected === "autoOps"} />
          <label htmlFor="autoOps" className="toggle-label">
            AutoOps
          </label>
          <p className="toggle-helperText">
            Primarily for sales, onboarding, and in some cases, product and
            customer support (CS), depending on their focus. For example, if a
            team member handles onboarding for AutoOps customers, they should
            use the AutoOps signature.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Toggle;
